import { MainPage } from './MainPage';

// eslint-disable-next-line import/no-default-export
export default MainPage;
